<template>
  <div class="smart-input" v-on-clickaway="onLostFocus" :class="classList">
    <label>
      <span class="placeholder"
        >{{ placeholder }}
        <span v-if="required" class="required">*</span>
      </span>
      <input
        type="text"
        :disabled="disabled"
        :readonly="disabled"
        :required="required"
        autocomplete="new-password"
        v-model="currentValue"
        @focus="isFocus = true"
        ref="input"
        tabindex="1"
        @input="onInput($event.target.value, $event.srcElement.value)"
        @keypress.enter="onEnter($event)"
        :is-close-modal="isCloseModal"
      />
    </label>
    <tooltip :text="tipsText" v-if="tipsText" class="tooltip"></tooltip>
    <line-loader v-if="isLoad"></line-loader>
    <div
      class="reset"
      v-if="!isLoad && notEmpty && !disabled"
      @click.stop="onClearClick($event.target)"
    >
      &times;
    </div>
    <div class="errors" v-if="error && isTouch">{{ error }}</div>
    <div v-if="nothingText" class="nothing-error">{{ nothingText }}</div>
    <div
      class="dropdown"
      v-if="isFocus && dropdownList && dropdownList.length > 0"
    >
      <div
        class="dropdown__item"
        v-for="item in dropdownList"
        tabindex="1"
        @click="setValue(item)"
        :key="item.name"
      >
        {{ item['CommonAlias'] }}
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import tooltip from '@/components/core/tooltip.vue';
import lineLoader from '@/components/core/lineLoader.vue';

export default {
  name: 'selectDropdown',
  mixins: [clickaway],
  props: {
    label: {
      type: String,
      default: 'title',
    },
    placeholder: {
      type: String,
      default: '',
    },
    auto: {
      type: String,
    },
    value: {
      type: Object,
    },
    availableItems: {
      type: Array,
      default: () => [],
    },
    isLoad: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
    },
    loadText: {
      type: String,
    },
    nothingText: {
      type: String,
    },
    debounce: {
      type: Number,
      default: 500,
    },
    tipsText: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    isPostal: {
      type: Boolean,
      default: false,
    },
    inputValue: {
      type: String,
    },
    isCloseModal: {
      type: Boolean,
    },
  },
  data() {
    return {
      currentValue: null,
      dropdownList: null,
      isFocus: false,
      isTouch: false,
      timeOut: null,
    };
  },
  watch: {
    value() {
      this.setCurrentValue();
    },
    availableItems(list) {
      this.dropdownList = list;
    },
  },
  created() {
    this.setCurrentValue();
  },
  computed: {
    classList() {
      return {
        'is-focus': this.isFocus,
        'is-error': this.isError && this.isTouch,
        'is-error-fon': this.isError,
        'is-postal': this.isPostal,
        'not-empty': !!this.notEmpty,
        'dropdown-open': this.dropdownList && this.dropdownList.length > 0,
        'is-required': this.required && !this.notEmpty && this.isPostal,
      };
    },
    notEmpty() {
      return !!this.currentValue;
    },
    isError() {
      return !!this.error && !!this.currentValue;
    },
    isRequired() {
      return this.required;
    },
    texts() {
      return {
        required: this.$t('Required'),
      };
    },
  },
  components: {
    tooltip,
    lineLoader,
  },
  methods: {
    setCurrentValue() {
      this.currentValue = this.value ? this.value[this.label] : '';
      if (this.isRequired) {
        this.validateRequired();
      }
    },
    setValue(value) {
      this.currentValue = value[this.label];
      this.dropdownList = null;
      this.currentValue = this.value ? this.value[this.label] : '';
      this.onLostFocus();
      this.$emit('user-change-input', this.currentValue);
      this.$emit('selected', value);
      this.$emit('change', value);
    },
    onClearClick(target) {
      this.currentValue = null;
      this.isFocus = !!target;
      this.$emit('clear');
    },
    onInput(value, inputValue) {
      this.inputValue = inputValue;

      this.$emit('user-change-input', value);
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        if (this.isFocus) {
          this.$emit('onSearch', value);
          this.$emit('onInputNewCity', value);
        }
      }, this.debounce);
    },
    onLostFocus() {
      this.inputValue = this.currentValue;
      if (!this.value) {
        if (this.dropdownList && this.dropdownList.length > 0) {
          if (this.inputValue === this.dropdownList[0].CountryAlias && this.dropdownList[0].CityAlias == null) {
            this.currentValue = this.dropdownList[0].CountryAlias;
            this.setValue(this.dropdownList[0]);
          } else if (this.inputValue === this.dropdownList[0].CityAlias) {
            this.currentValue = this.dropdownList[0].CityAlias;
            this.setValue(this.dropdownList[0]);
          } else if (this.inputValue === this.dropdownList[0].PostalCode) {
            this.currentValue = this.dropdownList[0].PostalCode;
          } else {
             this.error = 'Простите, по вашему запросу ничего не найдено';
          }
        } else {
          if (!!this.currentValue) {
            this.error = 'Простите, по вашему запросу ничего не найдено';
          }
        }
      }

      if (this.isFocus) {
        this.isTouch = true;
        this.isFocus = false;
        this.$emit('focusLost', this.inputValue === null);
      }
    },
    validateRequired() {
      if (this.currentValue === '' || this.currentValue === null) {
        this.$emit('error', this.texts.required);
      } else {
        this.$emit('error', '');
      }
    },
    onEnter(event) {
      if (this.dropdownList && this.dropdownList.length > 0) {
        this.setValue(this.dropdownList[0]);
      }
      event.target.blur();
    },
  },
};
</script>

<style scoped lang="scss">
$inputLeftPadding: 24;

.smart-input {
  position: relative;
  width: 100%;
  margin-bottom: 16px;
  border-radius: 4px;
  background-color: #f0f0f0;
  border: 1px solid #f0f0f0;

  transition: border-color 0.25s, background-color 0.25s;

  &.is-error {
    border: 1px solid red;
  }

  &.is-error-fon {
    background-color: #ffe6e6;
  }

  &.is-focus {
    border: 1px solid #ffcc00;
    background-color: #fff;
  }

  label {
    display: block;
    position: relative;
    cursor: pointer;
  }

  input {
    display: block;
    width: 100%;
    height: 54px;
    border: 0;
    padding: 20px $inputLeftPadding * 1px 4px;
    margin: 0;
    background-color: transparent;
    outline: none;

    color: #111111;
    font-size: 16px;
    font-weight: 300;
    line-height: 2;
  }

  .tooltip {
    position: absolute;

    + .reset {
      right: 2rem;
    }
  }

  .reset {
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translate(0, -50%);
    cursor: pointer;
  }

  .errors {
    position: absolute;
  }

  &.is-required {
    background-color: lighten(red, 45);
  }
}

.placeholder {
  position: absolute;
  left: $inputLeftPadding * 1px;
  top: 50%;

  transform: translate(0, -50%) scale(1);
  transform-origin: left center;
  transition: transform 0.15s ease;

  color: #888888;
  font-size: 15px;
  font-weight: 300;
  pointer-events: none;

  .is-focus &,
  .not-empty & {
    transform: translate(0, -100%) scale((11 / 15));
  }
}

.reset {
  width: 30px;
  height: 30px;

  padding: 2px;

  transition: font-size 0.15s ease;

  color: #ffcc00;
  font-size: 24px;
  line-height: 30px;
  text-align: center;

  cursor: pointer;

  &:hover {
    font-size: 30px;
  }
}

.nothing-error {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
  max-width: 100%;

  font-size: 13px;
  color: rgba(212, 4, 17, 0.76);
  padding: 12px $inputLeftPadding * 1px;

  border: 1px solid #ffcc00;
  border-radius: 4px;
  background-color: #fff;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: -1px;
  right: -1px;
  z-index: 1;
  max-height: 200px;
  overflow: auto;

  border: 1px solid #ffcc00;
  border-radius: 0 0 4px 4px;

  background: #fff;

  &__item {
    cursor: pointer;
    padding: 4px $inputLeftPadding * 1px;
    text-align: left;

    &:focus,
    &:hover {
      outline: none;
      background-color: #ffcc00;
    }
  }
}

.required {
  color: red;
}
</style>
